<script>
import BaseMn from '@/components/form/BaseMn.vue'
import dateUtils from '@/assets/js/dateUtils.js'
import humps from 'humps/humps.js'

export default {
  name: 'EditBase',
  mixins: [BaseMn],
  data () {
    return {
      activeTab: {},
      // pageMstr: {},
      // pageParams: {},
      udfDlgTitle: '',
      udfDlgWidth: '350px',
      udfObjectProps: {},
      udfFormRules: {},
      udfFormColumns: [],
      scrollTop: 0,
      attachParas: {},
      attachGenParas: {},
      utkddParas: {},
      uutkMstr: null,
      utkdDet: null,
      uutkNextRequire: false,
      uutkRtnRequire: false,
      canCancelTk: false,
      // upMstr: {},
      // mnMstr: {},
      dynamicFuncs: {},
      utkMstr: null,
      flowData: [],
      code: '',
      isMultiTk: false,
      codesStr: '',
      toolDis: 'det',
      loadByMainObj: false,
      loadByDetObj: false,
      reportUrl: 'about:blank',
      mainDataConfig: {
        hraderCondition: {},
        queryConditions: [],
        mhObjObjName: '',
        entityTable: '',
        querySql: '',
        keyProps: [],
        chkProp: '',
        chkUrl: '',
        chkPara: {
          ChkbyProp: '',
          ChkdateProp: ''
        },
        refreshDataUrl: '',
        pageNo: 1,
        pageNum: 100,
        total: 0,
        postChkPara: {
          postChkUrl: '',
          procName: '',
          para: {
          }
        },
        dataParas: {
          url: '',
          para: {
            querySql: '',
            columns: [],
            condition: [],
            order: []
          },
          filter: []
        },
        orderList: '',
        orderField: '',
        crtField: '',
        multitkField: '',
        ascType: ''
      },
      mainData: [],
      mainNavButtonList: [],
      mainNavButtonVisible: {},
      mainDataChangeFlag: true,
      currentIndex: 0,
      mainObjectState: -1, // -1.无数据  0.无状态  1.修改  2.新增  3.删除
      currentIndexOld: 0,
      mainObjectPropsOld: {},
      mainObjectPropsDefault: {},
      mainRules: {},
      mainFormSetting: {
        mainFormLabelWidth: '140px',
        mainFormLabelPosition: 'right',
        mainFormSize: 'mini',
        detTableSize: 'medium',
        mainFormDisabled: false,
        mailFormLayout: 12
      },
      mainShowSummary: false,
      detShowSummary: false,
      mPost: false,
      dPost: false,
      navButtonOtherList: [],
      navButtonOtherVisible: {},
      detData: [],
      detNavButtonList: [],
      detNavButtonVisible: {},
      detCurrentIndex: 0,
      detObjectState: 0,
      detChangeFlag: true,
      detCurrentIndexOld: 0,
      detObjectPropsOld: {},
      detObjectPropsDefault: {},
      detRules: {},
      detDataConfig: {
        mhObjObjName: '',
        keyProps: [],
        joinProps: {},
        entityTable: '',
        querySql: '',
        pageNo: 1,
        pageNum: 100,
        total: 0,
        postChkPara: {
          postChkUrl: '',
          procName: '',
          para: {}
        },
        dataParas: {
          entityTable: '',
          url: '',
          para: {}
        }
      },
      apprObject_: {},
      apprNextList_: [],
      apprRtnList_: [],
      apprTurnUserList_: [],
      searchCondition: '',
      autoLoadData: false,
      defaultQuery: [],
      queryColumns: [],
      orderColumns: [],
      queryIndex: -1,
      // bTabPaneHeight: 0,
      // dTabPaneHeight: 0
      UproxUser: false,
      uutkConfirm: false,
      tkStyleList_: {},
      tkStyleValue: ''
    }
  },
  computed: {
    apprUutkConfirm_ () {
      return this.uutkConfirm
    },
    apprActionTitle_ () {
      if (this.apprObject_.apprAction === 'A') {
        return this.$t('form.EditBase.agree')
      } else if (this.apprObject_.apprAction === 'R') {
        return this.$t('form.EditBase.fallBack')
      } else if (this.apprObject_.apprAction === 'T') {
        return this.$t('form.EditBase.referrals')
      } else {
        return ''
      }
    },
    detObjectProps_ () {
      if (this.detObjectState === 1) {
        return this.detObjectProps
      } else {
        return Object.assign({}, this.detObjectProps)
      }
    },
    dataIsChk () {
      if (this.mainDataConfig.chkProp === '') {
        return false
      } else {
        if ((this.mainObjectProps) && (this.mainObjectProps[this.mainDataConfig.chkProp] === true)) {
          return true
        } else {
          return false
        }
      }
    },
    dataInWorkFlow () {
      if (this.code === '') {
        return false
      } else {
        if ((this.utkMstr) && (this.utkMstr.utkStatus === '0' || this.utkMstr.utkStatus === '1')) {
          return true
        } else {
          return false
        }
      }
    },
    mainFormEdit () {
      if ((this.mainObjectState === -1) || (this.dataIsChk) || (this.dataInWorkFlow)) {
        return true
      } else {
        if ((!this.upMstr.upEdit) && (!this.upMstr.upNew)) {
          return true
        } else {
          if (((this.upMstr.upNew) && (this.mainObjectState === 2)) || (this.upMstr.upEdit)) {
            return false
          } else {
            return true
          }
        }
      }
    },
    detGridEdit () {
      if ((this.detObjectState === -1) || (this.dataIsChk) || (this.dataInWorkFlow)) {
        return true
      } else {
        if ((!this.upMstr.upEdit) && (!this.upMstr.upNew)) {
          return true
        } else {
          if (((this.upMstr.upNew) && (this.detObjectState === 2)) || (this.upMstr.upEdit)) {
            return false
          } else {
            return true
          }
        }
      }
    },
    flowPendState () {
      if ((this.mainObjectState === 0) && (this.upMstr.upWf) && (!this.dataIsChk) && ((!this.utkMstr) || (this.utkMstr.utkStatus === '9'))) {
        return true
      } else {
        return false
      }
    },
    flowApprState () {
      const that = this
      if ((that.mainObjectState === 0) && (that.uutkMstr)) {
        if ((that.uutkMstr.uutkStatus === '0') && (that.uutkMstr.uutkDuty.toUpperCase() === that.uuId_.toUpperCase())) {
          return true
        } if ((that.uutkMstr.uutkStatus === '0') && (that.UproxUser)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    flowRejectState () {
      const that = this
      if ((that.mainObjectState === 0) && (that.uutkMstr) && (that.utkdDet)) {
        if ((that.uutkMstr.uutkStatus === '0') && (that.uutkMstr.uutkDuty.toUpperCase() === that.uuId_.toUpperCase()) && (that.utkdDet.utkdCanRtn)) {
          return true
        } if ((that.uutkMstr.uutkStatus === '0') && (that.UproxUser) && (that.utkdDet.utkdCanRtn)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    flowTurnState () {
      const that = this
      if ((that.mainObjectState === 0) && (that.uutkMstr) && (that.utkdDet)) {
        if ((that.uutkMstr.uutkStatus === '0') && (that.uutkMstr.uutkDuty.toUpperCase() === that.uuId_.toUpperCase()) && (that.utkdDet.utkdCanTurn)) {
          return true
        } if ((that.uutkMstr.uutkStatus === '0') && (that.UproxUser) && (that.utkdDet.utkdCanTurn)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    flowCancelState () {
      const that = this
      if ((that.mainObjectState === 0) && (that.uutkMstr) && (that.utkMstr) && ((that.utkMstr.utkStatus === '-1') || (that.utkMstr.utkStatus === '0'))) {
        if (((that.utkMstr.utkStatus === '-1') && (that.uutkMstr.uutkDuty.toUpperCase() === that.uuId_.toUpperCase())) || (that.canCancelTk)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    detDataModify () {
      if ((this.mainObjectState === 0) && (this.upMstr.upEdit) && (!this.dataIsChk) && (!this.dataInWorkFlow)) {
        if ((this.detObjectState === 1) || (this.detObjectState === 2)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    detDataInsert () {
      if ((this.mainObjectState === 0) && (this.upMstr.upNew) && (!this.dataIsChk) && (!this.dataInWorkFlow)) {
        if ((this.detObjectState === 0) || (this.detObjectState === -1)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    detDataCancel () {
      if (this.mainObjectState === 0) {
        if ((this.detObjectState === 0) || (this.detObjectState === -1)) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    detDataDelete () {
      if ((this.mainObjectState === 0) && (this.upMstr.upDelete) && (!this.dataIsChk) && (!this.dataInWorkFlow)) {
        if (this.detObjectState === -1) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    preDetDataState () {
      if ((this.detCurrentIndex === 0) || (this.detCurrentIndex === -1)) {
        return true
      } else {
        return false
      }
    },
    nextDetDataState () {
      if (((this.detCurrentIndex + 1) === this.detData.length) || (this.detCurrentIndex === -1)) {
        return true
      } else {
        return false
      }
    },
    preMainDataState () {
      if ((this.currentIndex === 0) || (this.currentIndex === -1)) {
        return true
      } else {
        return false
      }
    },
    nextMainDataState () {
      if (((this.currentIndex + 1) === this.mainData.length) || (this.currentIndex === -1)) {
        return true
      } else {
        return false
      }
    },
    mainObjectProps_ () {
      if (this.mainObjectState === 1) {
        return this.mainObjectProps
      } else {
        return Object.assign({}, this.mainObjectProps)
      }
    },
    mainDataAppr () {
      if ((this.upMstr.upAprv) && (this.mainObjectState === 0) && (!this.dataIsChk)) {
        return true
      } else {
        return false
      }
    },
    mainDataRvsAppr () {
      if ((this.upMstr.upRvsAprv) && (this.mainObjectState === 0) && (this.dataIsChk)) {
        return true
      } else {
        return false
      }
    },
    mainDataExport () {
      if ((this.upMstr.upOutput) && (this.mainObjectState === 0)) {
        return true
      } else {
        return false
      }
    },
    mainDataPreview () {
      if ((this.upMstr.upPrntPreview) && (this.mainObjectState === 0) && (this.mnMstr.mnReport !== '')) {
        return true
      } else {
        return false
      }
    },
    mainDataModify () {
      if (((this.mainObjectState === 1) || (this.mainObjectState === 2)) && (this.upMstr.upEdit) && (!this.dataIsChk) && (!this.dataInWorkFlow)) {
        return true
      } else {
        return false
      }
    },
    mainDataInsert () {
      if (((this.mainObjectState === 0) || (this.mainObjectState === -1)) && (this.upMstr.upNew)) {
        return true
      } else {
        return false
      }
    },
    mainDataCancel () {
      if ((this.mainObjectState === 0) || (this.mainObjectState === -1)) {
        return false
      } else {
        return true
      }
    },
    mainDataDelete () {
      if ((this.mainObjectState === -1) || (!this.upMstr.upDelete) || (this.dataIsChk) || (this.dataInWorkFlow)) {
        return false
      } else {
        return true
      }
    },
    queryDataPermState () {
      if (this.upMstr.upList) {
        return true
      } else {
        return false
      }
    },
    utkStatus () {
      if (this.utkMstr) {
        return this.utkMstr.utkStatus
      } else {
        return ''
      }
    },
    attachPerm () {
      const that = this
      if (that.upMstr) {
        return {
          achInsert: that.upMstr.upAttachAdd,
          achView: that.upMstr.upAttachView,
          achDownload: that.upMstr.upAttachDownload,
          achDelete: that.upMstr.upAttachDel
        }
      } else {
        return {
          achInsert: false,
          achView: false,
          achDelete: false
        }
      }
    },
    action_ () {
      if (this.mainObjectState === 1) {
        return 'update'
      } else if (this.mainObjectState === 2) {
        return 'insert'
      } else if (this.mainObjectState === 3) {
        return 'delete'
      } else {
        return ''
      }
    },
    detAction_ () {
      if (this.detObjectState === 1) {
        return 'update'
      } else if (this.detObjectState === 2) {
        return 'insert'
      } else if (this.detObjectState === 3) {
        return 'delete'
      } else {
        return ''
      }
    },
    hasDetGrid () {
      if (this.detDataConfig.mhObjObjName !== '') {
        return true
      } else {
        return false
      }
    },
    hasUtkGrid () {
      if ((this.mnMstr.mnAllowWf) && (this.upMstr.upWf)) {
        return true
      } else {
        return false
      }
    },
    hasAttachGrid () {
      if ((this.mnMstr.mnAllowAttach) && (this.upMstr.upAttach)) {
        return true
      } else {
        return false
      }
    },
    isMainKeyProp () {
      if (this.mainObjectState === 2) {
        return false
      } else {
        return true
      }
    },
    isDetKeyProp () {
      if (this.detObjectState === 2) {
        return false
      } else {
        return true
      }
    },
    mainDetDirty () {
      if (((this.mainObjectState === 0) || (this.mainObjectState === -1)) &&
        ((this.detObjectState === 0) || (this.detObjectState === -1))) {
        return false
      } else {
        return true
      }
    },
    detDetDirty () {
      if ((this.detObjectState === 0) || (this.detObjectState === -1)) {
        return false
      } else {
        return true
      }
    },
    queryFiledList () {
      return this.queryColumns
    },
    orderFiledList () {
      return this.orderColumns
    },
    mainStripe () {
      if (this.dynamicFuncs._mainRowStyle) {
        return false
      } else {
        return true
      }
    },
    detStripe () {
      if (this.dynamicFuncs._detRowStyle) {
        return false
      } else {
        return true
      }
    }
  },
  components: {
  },
  methods: {
    // loadPageCheck: async function () {
    //   const that = this
    //   const para = {
    //     pageMnId: that.pageParams.id
    //   }
    //   const { data: res } = await this.$http.post('/users/getPageCheckMstrShow', para)
    //   if (res.data) {
    //     that.passData = res.data
    //     that.pageShow = 'Check'
    //   } else {
    //     that.pageShow = 'Base'
    //   }
    // },
    // passCheck () {
    //   const that = this
    //   that.$refs.passFormRef.validate(async (valid) => {
    //     if (valid) {
    //       const para = that.passData
    //       para.pageUser = that.uuId_
    //       const { data: res } = await this.$http.post('/users/CheckPageMnPass', para)
    //       if (res.data) {
    //         that.pageShow = 'Base'
    //       } else {
    //         that.pageShow = 'Check'
    //         that.$message(this.$t('form.UdfQueryJs.verificationCodeError'))
    //       }
    //     } else {
    //       return false
    //     }
    //   })
    // },
    // getPaneHeight (navHeight) {
    //   this.bTabPaneHeight = window.innerHeight - 40 - 30 - 31 - navHeight
    // },
    getDtableHeight (navHeight) {
      const that = this
      const height = navHeight + that.$refs.SecondMainForm.offsetHeight
      if (that.mtableHeight - height <= 100) {
        that.dTabPaneHeight = 200
      } else {
        that.dTabPaneHeight = that.mtableHeight - height
      }
    },
    befCloseDetDrawer (done) {
      if (this.detDetDirty) {
        this.$alert(this.$t('form.EditBase.dataNotSaved'), this.$t('form.EditBase.messageBox'), {
          confirmButtonText: this.$t('form.EditBase.confirm')
        })
      } else {
        done()
      }
    },
    preDetDataStep () {
      if (this.detDetDirty) {
        this.$alert(this.$t('form.EditBase.dataNotSaved'), this.$t('form.EditBase.messageBox'), {
          confirmButtonText: this.$t('form.EditBase.confirm')
        })
      } else {
        if ((this.detCurrentIndex === 0) || (this.detCurrentIndex === -1)) {

        } else {
          this.setDetGridCurrent(this.detData[this.detCurrentIndex - 1])
        }
      }
    },
    nextDetDataStep () {
      if (this.detDetDirty) {
        this.$alert(this.$t('form.EditBase.dataNotSaved'), this.$t('form.EditBase.messageBox'), {
          confirmButtonText: this.$t('form.EditBase.confirm')
        })
      } else {
        if (((this.detCurrentIndex + 1) === this.detData.length) || (this.detCurrentIndex === -1)) {

        } else {
          this.setDetGridCurrent(this.detData[this.detCurrentIndex + 1])
        }
      }
    },
    preMainDataStep () {
      if (this.mainDetDirty) {
        this.$alert(this.$t('form.EditBase.dataNotSaved'), this.$t('form.EditBase.messageBox'), {
          confirmButtonText: this.$t('form.EditBase.confirm')
        })
      } else {
        if ((this.currentIndex === 0) || (this.currentIndex === -1)) {

        } else {
          this.setMainGridCurrent(this.mainData[this.currentIndex - 1])
        }
      }
    },
    nextMainDataStep () {
      if (this.mainDetDirty) {
        this.$alert(this.$t('form.EditBase.dataNotSaved'), this.$t('form.EditBase.messageBox'), {
          confirmButtonText: this.$t('form.EditBase.confirm')
        })
      } else {
        if (((this.currentIndex + 1) === this.mainData.length) || (this.currentIndex === -1)) {

        } else {
          this.setMainGridCurrent(this.mainData[this.currentIndex + 1])
        }
      }
    },
    setDetFormData (newObj) {
      this.detObjectProps = newObj
    },
    changeDetData (selection, oldSelection) {
      if ((!selection) || (this.detData.length === 0)) {
        this.detObjectState = -1
      } else {
        if (this.detChangeFlag) {
          this.detObjectState = 0
        }
      }
      selection = selection || this.detObjectPropsDefault
      this.detObjectPropsOld = oldSelection || this.detObjectPropsOld
      this.setDetFormData(selection)

      this.detChangeFlag = true
      if ((selection) && (selection.index !== 'undefined')) {
        this.detCurrentIndex = selection.index
      }
    },
    detDataChange (selection, oldSelection) {
      const that = this
      that.changeDetData(selection, oldSelection)
    },
    queryDataChangeExec (selection) {
      if ((selection) && (typeof (selection.index) !== 'undefined')) {
        this.queryIndex = selection.index
      }
    },
    setMainFormData (newObj) {
      this.mainObjectProps = newObj
    },
    mainDataChange (selection, oldSelection) {
      if ((!selection) || (this.mainData.length === 0)) {
        this.mainObjectState = -1
      } else {
        this.mainObjectState = 0
      }
      selection = selection || this.mainObjectPropsDefault
      this.mainObjectPropsOld = oldSelection || this.mainObjectPropsDefault
      this.setMainFormData(selection)
      this.mainDataChangeFlag = true
      if ((selection) && (selection.index !== 'undefined')) {
        this.currentIndex = selection.index
      }
      this.activeTabEvents()
      const mainDataChangeExt = this.mainDataChangeExt
      if (typeof mainDataChangeExt === 'function') {
        mainDataChangeExt()
      }
      if (this.code !== '') {
        this.loadUtkMstr()
      }
    },
    mainRowClick (row, column, event) {
      this.currentIndex = row.index
    },
    mainGridDbClick () {
      this.$refs.editslot.activeTab = 'detail_second'
      this.loadDetGridData()
    },
    detRowClick (row, column, event) {
      this.detCurrentIndex = row.index
    },
    detRowDblClick (row, column, event) {
      this.$refs.editslot.showDetDrawer = true
    },
    mainRowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    iCellStyle ({ row, column, rowIndex, columnIndex }) {
      const style = { padding: '0px 2px' }
      return style
    },
    mainCellStyle ({ row, column, rowIndex, columnIndex }) {
      const that = this
      if (that.dynamicFuncs._mainCellStyle) {
        return that.dynamicFuncs._mainCellStyle({ row, column, rowIndex, columnIndex })
      } else {
        return {}
      }
    },
    detCellStyle ({ row, column, rowIndex, columnIndex }) {
      const that = this
      if (that.dynamicFuncs._detCellStyle) {
        return that.dynamicFuncs._detCellStyle({ row, column, rowIndex, columnIndex })
      } else {
        return {}
      }
    },
    mainRowStyle ({ row, rowIndex }) {
      const that = this
      if (that.dynamicFuncs._mainRowStyle) {
        return that.dynamicFuncs._mainRowStyle({ row, rowIndex })
      } else {
        return 'height: 35px;white-space: nowrap;max-height:40px;'
      }
    },
    detRowStyle ({ row, rowIndex }) {
      const that = this
      if (that.dynamicFuncs._detRowStyle) {
        return that.dynamicFuncs._detRowStyle({ row, rowIndex })
      } else {
        return 'height: 35px;white-space: nowrap;max-height:40px;'
      }
    },
    dataFormat (row, column, cellValue, index, vtype, format) {
      if (vtype === 'date') {
        return dateUtils.formatDate(cellValue, format)
      } else {
        return cellValue
      }
    },
    setDetGridCurrent (row) {
      this.$refs.detGrid.setCurrentRow(row)
    },
    setMainGridCurrent (row) {
      this.$refs.mainGrid.setCurrentRow(row)
    },
    activeTabEvents () {
      if (this.$refs.editslot.activeTab === 'detail_second') {
        this.loadDetGridData()
      }
      if (this.$refs.editslot.activeTab === 'tab_fifth') {
        this.loadUtkMstr()
        this.loadUutkMstr()
      }
      if (this.$refs.editslot.activeTab === 'tab_fourth') {
        this.getAttachParas()
      }
      if (this.$refs.editslot.activeTab === 'tab_fifth2') {
        this.getUtkddParas()
      }
    },
    getUtkddParas () {
      const that = this
      const props = that.mainDataConfig.keyProps
      if (that.mainObjectState === 0) {
        const nbr = that.mainObjectProps[props[0]]
        let lot = ''
        if (props.length > 1) {
          lot = that.mainObjectProps[props[1]]
        }
        that.utkddParas = {
          utkddNbr: nbr,
          utkddLot: lot,
          app: that.app_,
          site: that.site_,
          mnId: that.mnId_,
          thistime: that.$Any.getCurrentDate('yyyy-MM-dd HH:mm:ss')
        }
      } else {
        that.utkddParas = {
          utkddNbr: '',
          utkddLot: '',
          app: that.app_,
          site: that.site_,
          mnId: that.mnId_,
          thistime: that.$Any.getCurrentDate('yyyy-MM-dd HH:mm:ss')
        }
      }
    },
    getAttachGenParas () {
      const that = this
      const props = that.mainDataConfig.keyProps

      const nbr = that.mainObjectProps[props[0]]
      let lot = ''
      if (props.length > 1) {
        lot = that.mainObjectProps[props[1]]
      }
      that.attachGenParas = {
        mnId: that.mnId_,
        uuId: that.uuId_,
        app: that.app_,
        site: that.site_,
        action: that.action_,
        nbr: nbr,
        lot: lot,
        code: that.code,
        lang: that.lang_,
        flag: 0,
        msg: ''
      }
    },
    getAttachParas () {
      const that = this
      const props = that.mainDataConfig.keyProps
      if (that.mainObjectState === 0) {
        const nbr = that.mainObjectProps[props[0]]
        let lot = ''
        if (props.length > 1) {
          lot = that.mainObjectProps[props[1]]
        }
        that.attachParas = {
          attachNbr: nbr,
          attachLot: lot,
          attachCode: that.code,
          attachApp: that.app_,
          attachSite: that.site_,
          mnId: that.mnId_
        }
      } else {
        that.attachParas = {
          attachNbr: '',
          attachLot: '',
          attachCode: that.code,
          attachApp: that.app_,
          attachSite: that.site_,
          mnId: that.mnId_
        }
      }
    },
    getDetailParaData () {
      const obj = {}
      const props = this.mainDataConfig.keyProps
      const detKeyProps = this.detDataConfig.joinProps
      for (const i in props) {
        obj[detKeyProps[props[i]]] = this.mainObjectProps[props[i]]
      }
      this.detDataConfig.dataParas.para.querySql = this.$Any.replaceConstValue(this.detDataConfig.querySql, this.constObj_)
      this.detDataConfig.dataParas.para.columns = this.detColumns
      const para = this.detDataConfig.dataParas.para
      return Object.assign(para, obj)
    },
    initConfig: function () {
      const that = this
      that.mainDataConfig.dataParas.para.pageNo = that.mainDataConfig.pageNo
      that.mainDataConfig.dataParas.para.pageNum = that.mainDataConfig.pageNum
      that.mainDataConfig.dataParas.para.lang = that.lang_
      that.mainDataConfig.dataParas.para.site = that.site_
      that.mainDataConfig.dataParas.para.app = that.defApp_

      that.detDataConfig.dataParas.para.pageNo = that.detDataConfig.pageNo
      that.detDataConfig.dataParas.para.pageNum = that.detDataConfig.pageNum
      that.detDataConfig.dataParas.para.lang = that.lang_
      that.detDataConfig.dataParas.para.site = that.site_
      that.detDataConfig.dataParas.para.app = that.defApp_

      that.pageParams = Object.assign(that.pageParams, that.$route.params)
      const canCancelTk_ = that.$Any.checkPermBySysCfg(that.uuId_, 'SYSCFG_TK', 'sys_char1')
      canCancelTk_.then((result) => {
        that.canCancelTk = result
      })
      that.loadPageCheck()
      that.loadUpMstr()
      that.loadMnMstr().then(function () {
        that.loadPageMstr().then(function () {
          that.loadMhobj()
        })
      })
      that.loadtkStyleList()
    },
    exportDet: async function () {
      const that = this
      const fileName = that.mnMstr.mnDesc + '_detail.xls'
      const total = that.detDataConfig.total
      if (total > 0) {
        const url = that.detPostUrl.queryUrl
        that.detDataConfig.dataParas.para.pageNum = total
        try {
          const qpara = that.detDataConfig.dataParas.para
          const { data: res } = await that.$http.post(url, qpara)
          if (res.data) {
            const pp = {
              list: res.data.list,
              para: qpara,
              fileName: fileName,
              title: that.mnMstr.mnDesc
            }
            that.$http.post('/edoc/responseExportExcel', pp, {
              responseType: 'blob'
            }).then((response) => {
              const content = response.data
              const blob = new Blob([content])
              const aLink = document.createElement('a')
              const url = URL.createObjectURL(blob)
              if ('download' in aLink) {
                aLink.download = fileName
                aLink.style.display = 'none'
                aLink.href = url
                document.body.appendChild(aLink)
                aLink.click()
                URL.revokeObjectURL(aLink.href)
                document.body.removeChild(aLink)
              } else {
                navigator.msSaveBlob(blob, fileName)
              }
            })
          }
        } finally {
          that.detDataConfig.dataParas.para.pageNum = that.detDataConfig.pageNum
        }
      }
    },
    otherExpend: async function (command) {
      const that = this
      const cobj = that.$Any.getArrayObjByDefProp(that.navButtonOtherList, 'key', command)
      const func = cobj.function
      if (func) {
        func(that)
      }
    },
    preExp: async function (command) {
      const that = this
      if (command === 'preMain') {
        let flag = true
        if (that.dynamicFuncs._previewRpt) {
          flag = await that.dynamicFuncs._previewRpt(that)
        }
        if (!flag) {
          return
        }
        if (that.mnMstr.mnReport !== '') {
          var KEYNBR = ''
          var KEYLOT = ''
          const props = that.mainDataConfig.keyProps
          // for (const i in props) {
          //   if (i === 0) {
          //     KEYNBR = that.mainObjectProps[props[i]]
          //   } else if (i === 1) {
          //     KEYLOT = that.mainObjectProps[props[i]]
          //   }
          // }
          KEYNBR = that.mainObjectProps[props[0]]
          if (props.length > 1) {
            KEYLOT = that.mainObjectProps[props[1]]
          }
          const timestamp = Date.parse(new Date())
          that.reportUrl = '/ureport/pdf/show?_u=uf:' + that.mnMstr.mnReport + '&KEY_NBR=' + KEYNBR + '&KEY_LOT=' + KEYLOT + '&TIME=' + timestamp
          that.$refs.editslot.showReportViewer = true
        }
      } else if (command === 'expMain') {
        let flag = true
        if (that.dynamicFuncs._exportMain) {
          flag = await that.dynamicFuncs._exportMain(that)
        }
        if (!flag) {
          return
        }
        const fileName = that.mnMstr.mnDesc + '.xls'
        const total = that.mainDataConfig.total
        if (total > 0) {
          const url = that.mainPostUrl.queryUrl
          that.mainDataConfig.dataParas.para.pageNum = total
          try {
            const qpara = that.mainDataConfig.dataParas.para
            const { data: res } = await that.$http.post(url, qpara)
            if (res.data) {
              const pp = {
                list: res.data.list,
                para: qpara,
                fileName: fileName,
                title: that.mnMstr.mnDesc
              }

              that.$http.post('/edoc/responseExportExcel', pp, {
                responseType: 'blob'
              }).then((response) => {
                const content = response.data
                const blob = new Blob([content])
                const aLink = document.createElement('a')
                const url = URL.createObjectURL(blob)
                if ('download' in aLink) {
                  aLink.download = fileName
                  aLink.style.display = 'none'
                  aLink.href = url
                  document.body.appendChild(aLink)
                  aLink.click()
                  URL.revokeObjectURL(aLink.href)
                  document.body.removeChild(aLink)
                } else {
                  navigator.msSaveBlob(blob, fileName)
                }
              })
            }
          } finally {
            that.mainDataConfig.dataParas.para.pageNum = that.mainDataConfig.pageNum
          }
        }
      }
    },
    apprCurrent: function (command) {
      const that = this
      if (command === 'appr') {
        that.$confirm(that.$t('form.EditBase.reviewThisDocument'), that.$t('form.EditBase.pleaseConfirm'), {
          confirmButtonText: that.$t('form.EditBase.confirm'),
          cancelButtonText: that.$t('form.EditBase.cancel'),
          type: 'warning'
        }).then(async () => {
          const url = that.mainDataConfig.chkUrl
          if (url !== '') {
            const props = that.mainDataConfig.keyProps
            const nbr = that.mainObjectProps[props[0]]
            let lot = ''
            if (props.length > 1) {
              lot = that.mainObjectProps[props[1]]
            }
            const para = {
              app: that.app_,
              site: that.site_,
              mnId: that.mnId_,
              uu: that.uuId_,
              code: that.code,
              nbr: nbr,
              lot: lot,
              check: 0,
              pType: 'A',
              lang: that.lang_,
              flag: 0,
              msg: ''
            }
            const { data: res } = await that.$http.post(url, para)
            if (res.data.flag === -1) {
              const refreshUrl = that.mainDataConfig.refreshDataUrl
              if (refreshUrl !== '') {
                const { data: refreshRes } = await that.$http.post(refreshUrl, para)
                that.mainObjectProps = Object.assign(that.mainObjectProps, refreshRes.data)
                that.mainData[that.currentIndex] = Object.assign(that.mainData[that.currentIndex], refreshRes.data)
              }
              // that.mainObjectState = 0
              that.mainObjectProps[that.mainDataConfig.chkProp] = true
              that.mainObjectProps[that.mainDataConfig.chkPara.ChkbyProp] = that.uuId_
              that.mainObjectProps[that.mainDataConfig.chkPara.ChkdateProp] = that.$Any.getCurrentDate('yyyy-MM-dd HH:mm:ss')
              that.mainObjectState = 1
              that.postMainData()
              that.$alert(that.$t('form.EditBase.successfulAudit'), that.$t('form.EditBase.messageBox'), {
                confirmButtonText: that.$t('form.EditBase.confirm')
              })
            } else {
              that.$alert(res.data.msg, that.$t('form.EditBase.messageBox'), {
                confirmButtonText: that.$t('form.EditBase.confirm')
              })
            }
          } else {
            if (that.mainDataConfig.chkProp !== '') {
              that.mainObjectProps[that.mainDataConfig.chkProp] = true
              that.mainObjectProps[that.mainDataConfig.chkPara.ChkbyProp] = that.uuId_
              that.mainObjectProps[that.mainDataConfig.chkPara.ChkdateProp] = that.$Any.getCurrentDate('yyyy-MM-dd HH:mm:ss')
              that.mainObjectState = 1
              that.postMainData()
              that.$alert(that.$t('form.EditBase.successfulAudit'), that.$t('form.EditBase.messageBox'), {
                confirmButtonText: that.$t('form.EditBase.confirm')
              })
            }
          }
        }).catch(() => {
        })
      } else if (command === 'rvsAppr') {
        that.$confirm(that.$t('form.EditBase.counterDocument'), that.$t('form.EditBase.pleaseConfirm'), {
          confirmButtonText: that.$t('form.EditBase.confirm'),
          cancelButtonText: that.$t('form.EditBase.cancel'),
          type: 'warning'
        }).then(async () => {
          const url = that.mainDataConfig.chkUrl
          if (url !== '') {
            const props = that.mainDataConfig.keyProps
            const nbr = that.mainObjectProps[props[0]]
            let lot = ''
            if (props.length > 1) {
              lot = that.mainObjectProps[props[1]]
            }
            const para = {
              app: that.app_,
              site: that.site_,
              mnId: that.mnId_,
              uu: that.uuId_,
              code: that.code,
              nbr: nbr,
              lot: lot,
              check: 0,
              pType: 'R',
              lang: that.lang_,
              flag: 0,
              msg: ''
            }
            const { data: res } = await that.$http.post(url, para)
            if (res.data.flag === -1) {
              const refreshUrl = that.mainDataConfig.refreshDataUrl
              if (refreshUrl !== '') {
                const { data: refreshRes } = await that.$http.post(refreshUrl, para)
                that.mainObjectProps = Object.assign(that.mainObjectProps, refreshRes.data)
                that.mainData[that.currentIndex] = Object.assign(that.mainData[that.currentIndex], refreshRes.data)
              }
              that.mainObjectProps[that.mainDataConfig.chkProp] = false
              that.mainObjectProps[that.mainDataConfig.chkPara.ChkbyProp] = ''
              that.mainObjectProps[that.mainDataConfig.chkPara.ChkdateProp] = null
              that.mainObjectState = 1
              that.postMainData()
              that.$alert(that.$t('form.EditBase.successfulCancelAudit'), that.$t('form.EditBase.messageBox'), {
                confirmButtonText: that.$t('form.EditBase.confirm')
              })
            } else {
              that.$alert(res.data.msg, that.$t('form.EditBase.messageBox'), {
                confirmButtonText: that.$t('form.EditBase.confirm')
              })
            }
          } else {
            if (that.mainDataConfig.chkProp !== '') {
              that.mainObjectProps[that.mainDataConfig.chkProp] = false
              that.mainObjectProps[that.mainDataConfig.chkPara.ChkbyProp] = ''
              that.mainObjectProps[that.mainDataConfig.chkPara.ChkdateProp] = null
              that.mainObjectState = 1
              that.postMainData()
              that.$alert(that.$t('form.EditBase.successfulCancelAudit'), that.$t('form.EditBase.messageBox'), {
                confirmButtonText: that.$t('form.EditBase.confirm')
              })
            }
          }
        }).catch(() => {

        })
      }
    },
    apprCurrent2: function (command) {
      const that = this
      if (command === 'appr') {
        that.$confirm(that.$t('form.EditBase.reviewThisDocument'), that.$t('form.EditBase.pleaseConfirm'), {
          confirmButtonText: that.$t('form.EditBase.confirm'),
          cancelButtonText: that.$t('form.EditBase.cancel'),
          type: 'warning'
        }).then(async () => {
          const obj = {}
          const props = that.mainDataConfig.keyProps
          for (const i in props) {
            obj[props[i]] = that.mainObjectProps[props[i]]
          }
          obj.sign = true
          const url = that.mainDataConfig.chkUrl
          if (url !== '') {
            const { data: res } = await that.$http.post(url, obj)
            if (res.data.flag === -1) {
              const refreshUrl = that.mainDataConfig.refreshDataUrl
              const { data: res } = await that.$http.post(refreshUrl, obj)
              that.$alert(that.$t('form.EditBase.successfulAudit'), that.$t('form.EditBase.messageBox'), {
                confirmButtonText: that.$t('form.EditBase.confirm')
              })
              that.mainObjectProps = Object.assign(that.mainObjectProps, res.data)
              that.mainData[that.currentIndex] = Object.assign(that.mainData[that.currentIndex], res.data)
              that.mainObjectState = 0
            } else {
              that.$alert(res.data.msg, that.$t('form.EditBase.messageBox'), {
                confirmButtonText: that.$t('form.EditBase.confirm')
              })
            }
          } else {
            if (that.mainDataConfig.chkProp !== '') {
              that.mainObjectProps[that.mainDataConfig.chkProp] = true
              that.mainObjectState = 1
              that.postMainData()
            }
          }
        }).catch(() => {
        })
      } else if (command === 'rvsAppr') {
        const url = that.mainDataConfig.chkUrl
        that.$confirm(that.$t('form.EditBase.counterDocument'), that.$t('form.EditBase.pleaseConfirm'), {
          confirmButtonText: that.$t('form.EditBase.confirm'),
          cancelButtonText: that.$t('form.EditBase.cancel'),
          type: 'warning'
        }).then(async () => {
          if (url === '') {
            if (that.mainDataConfig.chkProp !== '') {
              that.mainObjectProps[that.mainDataConfig.chkProp] = false
              that.mainObjectState = 1
              that.postMainData()
            }
          }
        }).catch(() => {

        })
      }
    },
    udfDlgCancel: function () {
      const that = this
      if (that.dynamicFuncs._udfDlgCancel) {
        that.dynamicFuncs._udfDlgCancel(that)
      } else {
        that.$refs.editslot.showUdfFormDlg = false
      }
    },
    udfDlgConfirm: function () {
      const that = this
      if (that.dynamicFuncs._udfDlgConfirm) {
        that.dynamicFuncs._udfDlgConfirm(that)
      }
    },
    mainNavButtonClick: function (func) {
      const that = this
      if (func) {
        func(that)
      }
    },
    detNavButtonClick: function (func) {
      const that = this
      if (func) {
        func(that)
      }
    },
    createPageCreateFunc: function (pageCreated) {
      const that = this
      if ((!pageCreated) || (pageCreated === '')) {
        return false
      }
      const obj = null
      // eslint-disable-next-line no-eval
      eval('obj = ' + pageCreated)
      that.dynamicFuncs = obj
    },
    createPageMountedFunc: function (pageMounted) {
      const that = this
      if ((!pageMounted) || (pageMounted === '')) {
        return false
      }
      const obj = null
      // eslint-disable-next-line no-eval
      eval('obj = ' + pageMounted)
      obj(that)
    },
    // 加载页面配置
    loadPageMstr: async function () {
      const that = this
      const mnPageConfig = that.mnMstr.mnPageConfig
      if ((mnPageConfig) && (mnPageConfig !== '')) {
        const url = '/users/getPageMstrByCode/' + mnPageConfig
        const { data: res } = await that.$http.get(url)
        that.pageMstr = res.data
        that.createPageCreateFunc(that.pageMstr.pageCreated)
        that.createPageMountedFunc(that.pageMstr.pageMounted)
        if (that.pageMstr.pageMcode !== '') {
          that.mainDataConfig.mhObjObjName = that.pageMstr.pageMcode
          that.loadByMainObj = true
        }
        if (that.pageMstr.pageDcode !== '') {
          that.detDataConfig.mhObjObjName = that.pageMstr.pageDcode
          that.loadByDetObj = true
        }
        if (that.pageMstr.pageTcode !== '') {
          // 多流程
          if (that.pageMstr.pageMultiTk) {
            that.code = ''
            that.isMultiTk = true
            that.codesStr = that.pageMstr.pageTcode
          } else {
            that.code = that.pageMstr.pageTcode
          }
        }
        that.autoLoadData = that.pageMstr.pageLoadData
        if (that.pageMstr.pageNum > 0) {
          that.mainDataConfig.pageNum = that.pageMstr.pageNum
        }
        if (that.pageMstr.pageDataFilter !== '') {
          that.mainDataConfig.dataParas.filter = JSON.parse(that.$Any.replaceConstValue(that.pageMstr.pageDataFilter, that.constObj_))
        }
        const pageQryCode = that.pageMstr.pageDefaultQry
        if ((pageQryCode) && (pageQryCode !== '')) {
          const qryPara = {
            mqrydCode: pageQryCode
          }
          const { data: res2 } = await that.$http.post('/users/getListMqrydDetUsed', qryPara)
          that.loadDefaultQry(res2.data)
        }
      }
    },
    // loadUpMstr: async function () {
    //   const site = window.sessionStorage.getItem('currentSite')
    //   const menuId = this.pageParams.id
    //   const para = {
    //     site: site,
    //     mn: menuId
    //   }
    //   const { data: res } = await this.$http.post('/users/getUserMnUp', para)
    //   this.upMstr = res.data[0]
    // },
    // loadMnMstr: async function () {
    //   const that = this
    //   const menuId = that.pageParams.id
    //   const para = {
    //     mnMenuId: menuId
    //   }
    //   const { data: res } = await that.$http.post('/users/getMnMstrById', para)
    //   that.mnMstr = res.data
    //
    //   const mnPageConfig = that.mnMstr.mnPageConfig
    //   if ((mnPageConfig) && (mnPageConfig !== '')) {
    //     const url = '/users/getPageMstrByCode/' + mnPageConfig
    //     const { data: res } = await that.$http.get(url)
    //     that.pageMstr = res.data
    //     if (that.pageMstr.pageMcode !== '') {
    //       that.mainDataConfig.mhObjObjName = that.pageMstr.pageMcode
    //       that.loadByMainObj = true
    //     }
    //     if (that.pageMstr.pageDcode !== '') {
    //       that.detDataConfig.mhObjObjName = that.pageMstr.pageDcode
    //       that.loadByDetObj = true
    //     }
    //     if (that.pageMstr.pageTcode !== '') {
    //       that.code = that.pageMstr.pageTcode
    //     }
    //     that.autoLoadData = that.pageMstr.pageLoadData
    //     if (that.pageMstr.pageNum > 0) {
    //       that.mainDataConfig.pageNum = that.pageMstr.pageNum
    //     }
    //     if (that.pageMstr.pageDataFilter !== '') {
    //       that.mainDataConfig.dataParas.filter = JSON.parse(that.$Any.replaceConstValue(that.pageMstr.pageDataFilter, that.constObj_))
    //     }
    //     const pageQryCode = that.pageMstr.pageDefaultQry
    //     if ((pageQryCode) && (pageQryCode !== '')) {
    //       const qryPara = {
    //         mqrydCode: pageQryCode
    //       }
    //       const { data: res2 } = await that.$http.post('/users/getListMqrydDetUsed', qryPara)
    //       that.loadDefaultQry(res2.data)
    //     }
    //   }
    //   that.loadMhobj()
    // },
    awaitQueryColumnsPushItem: async function (item) {
      const that = this
      const kv = item.mqrydKvMap
      let kvList = {}
      if (kv !== '') {
        await that.$Any.getMapkvOptions(kv, that.constObj_).then(function (list) {
          kvList = list
        })
      }
      that.queryColumns.push({
        key: item.mqrydField,
        type: item.mqrydType,
        prop: item.mqrydField,
        label: item.mqrydName,
        default: item.mqrydValue,
        typeExt: item.mqrydTypeExt,
        detSQl: item.mqrydDetSql,
        kvList: kvList
      })
    },
    loadDefaultQry: async function (array) {
      const that = this
      if ((array) && (array.length > 0)) {
        const defArray = array.filter(item => item.mqrydDefault === true)
        const orderArray = array.filter(item => item.mqrydOrder === true)
        for (const item of defArray) {
          const kv = item.mqrydKvMap
          let qKvList = {}
          if (kv !== '') {
            await that.$Any.getMapkvOptions(kv, that.constObj_).then(function (list) {
              qKvList = list
            })
          }
          that.defaultQuery.push({
            qJoin: item.mqrydJoin,
            qField: item.mqrydField,
            qOp: item.mqrydOp,
            qValue: item.mqrydValue,
            qType: item.mqrydType,
            qTypeExt: item.mqrydTypeExt,
            qDetSQl: item.mqrydDetSql,
            qKvList: qKvList
          })
        }
        that.mainDataConfig.queryConditions = that.defaultQuery
        that.queryIndex = 0
        for (const item of array) {
          await that.awaitQueryColumnsPushItem(item)
        }
        for (const item of orderArray) {
          if (item.mqrydDefaultAsc !== '') {
            that.mainDataConfig.orderField = item.mqrydField
            that.mainDataConfig.ascType = item.mqrydDefaultAsc
          }
          that.orderColumns.push({
            key: item.mqrydField,
            value: item.mqrydField,
            type: item.mqrydType,
            prop: item.mqrydField,
            label: item.mqrydName,
            default: item.mqrydValue,
            asc: item.mqrydDefaultAsc
          })
        }
        that.mainDataConfig.orderList = that.orderColumns
      } else {
        that.mainDataConfig.queryConditions = that.defaultQuery
        that.mainDataConfig.orderList = that.orderColumns
        that.queryIndex = 0
      }
    },
    loadMhobj: function () {
      const that = this
      that.loadMhobjObj().then(function () {
        const mainOnInsert = that.mainOnInsert
        if (typeof mainOnInsert === 'function') {
          mainOnInsert()
        }
        that.loadMainData(false).then(function () {
          that.setMainGridCurrent(that.mainData[0])
          const aftLoadMainData = that.aftLoadMainDataExt
          if (typeof aftLoadMainData === 'function') {
            aftLoadMainData()
          }
          if (that.dynamicFuncs._loadMainDataAft) {
            that.dynamicFuncs._loadMainDataAft(that)
          }
        })
      })
      that.loadMhobjdDetObj().then(function () {
        const detOnInsert = that.detOnInsert
        if (typeof detOnInsert === 'function') {
          detOnInsert()
        }
      })
    },
    loadUdfFormMhobjObj: async function (udfFormCode) {
      const that = this
      const lang = localStorage.getItem('lang')
      const para = {
        mhobjCode: udfFormCode,
        mhobjdCode: udfFormCode,
        mhobjLang: lang,
        mhobjApp: '',
        mhobjSite: ''
      }
      const { data: res } = await that.$http.post('/users/queryByObj', para)
      if (res.data) {
        const list = res.data.mhobjdDetList
        const columns = []
        for (const i in list) {
          that.udfObjectProps[list[i].mhobjdProp] = that.$Any.getTypeDefaultValue(list[i].mhobjdType)
          let hqField = list[i].mhobjdHqField
          if ((hqField === '') && (list[i].mhobjdHq !== '')) {
            hqField = list[i].mhobjdProp
          }
          const rstField = that.$Any.strToArray(hqField, ',')
          const maplist = await that.$Any.getMapkvOptions(list[i].mhobjdMapvalues, that.constObj_)
          let allow = true
          if (list[i].mhobjdFieldPerm !== '') {
            allow = await that.$Any.checkPerm(that.uuId_, list[i].mhobjdFieldPerm)
          }
          const onInsertStr = list[i].mhobjdOninsert
          let onInsert = {}
          if (onInsertStr !== '') {
            onInsert = JSON.parse(onInsertStr)
          }
          // let gridSlot = []
          // if (list[i].mhobjdGridSlot !== '') {
          //   gridSlot = JSON.parse(list[i].mhobjdGridSlot)
          // }
          const gridSlotStr = list[i].mhobjdGridSlot
          let gridSlot = {}
          if (gridSlotStr !== '') {
            gridSlot = JSON.parse(gridSlotStr)
          }
          columns.push({
            key: list[i].mhobjdProp,
            col: list[i].mhobjdCols,
            row: list[i].mhobjdRows,
            align: list[i].mhobjdGridAlign,
            textRows: list[i].mhobjdMin,
            type: list[i].mhobjdType,
            prop: list[i].mhobjdProp,
            label: list[i].mhobjdLabel,
            width: list[i].mhobjdWidth,
            mainKey: list[i].mhobjdMainKey,
            required: list[i].mhobjdRequired,
            clearable: list[i].mhobjdClearable,
            display: list[i].mhobjdDisplay && allow,
            formDisplay: list[i].mhobjdFormDisplay && allow,
            order: list[i].mhobjdOrder,
            formOrder: list[i].mhobjdFormOrder,
            typeExtends: list[i].mhobjdTypeExtends,
            readOnly: list[i].mhobjdReadonly,
            default: list[i].mhobjdDefault,
            format: list[i].mhobjdFormat,
            hq: list[i].mhobjdHq,
            rstField: rstField,
            ref: list[i].mhobjdRef,
            icon: list[i].mhobjdTrigger,
            validType: list[i].mhobjdValidatorType,
            validator: list[i].mhobjdValidator,
            overToolTip: list[i].mhobjdOvertooltip,
            efileParas: list[i].mhobjdFileParas,
            gridSort: list[i].mhobjdGridSort,
            gridFixed: list[i].mhobjdGridFixed,
            zeroShow: list[i].mhobjdZeroShow,
            gridSlot: gridSlot,
            onInsert: onInsert,
            mapValues: maplist
          })
          const aRules = []
          if (list[i].mhobjdRequired === true) {
            aRules.push({
              required: true,
              message: list[i].mhobjdLabel + that.$t('form.EditBase.notBeEmpty'),
              trigger: 'blur'
            })
          }
          if ((list[i].mhobjdLength > 0) && (list[i].mhobjdType === 'string')) {
            aRules.push({
              max: list[i].mhobjdLength,
              message: that.$t('form.EditBase.characterLength') + list[i].mhobjdLength,
              trigger: 'blur'
            })
          }
          if (list[i].mhobjdValidator !== '') {
            aRules.push({
              validator: (rule, value, callback) => {
                const oldValue = that.udfObjectProps[list[i].mhobjdProp]
                that.$Any.bindValidator(value, callback, that, that.mainObjectProps, oldValue, that.mainObjectState, that.mPost, list[i].mhobjdValidator)
              },
              trigger: 'blur'
            })
          }
          if (list[i].mhobjdOnset !== '') {
            aRules.push({
              validator: (rule, value, callback) => {
                const oldValue = that.udfObjectProps[list[i].mhobjdProp]
                that.$Any.bindValidatorSet(value, callback, that, that.mainObjectProps, oldValue, that.mainObjectState, that.mPost, list[i].mhobjdOnset)
              },
              trigger: 'blur'
            })
          }
          if (list[i].mhobjdValidatorChange !== '') {
            aRules.push({
              validator: (rule, value, callback) => {
                const oldValue = that.udfObjectProps[list[i].mhobjdProp]
                that.$Any.bindValidatorChange(value, callback, that, that.mainObjectProps, oldValue, that.mainObjectState, that.mPost, list[i].mhobjdValidatorChange)
              },
              trigger: 'change'
            })
          }
          that.udfFormRules[list[i].mhobjdProp] = aRules
        }
        that.udfFormColumns = columns
      }
    },
    loadMhobjObj: async function () {
      const that = this
      const objCode = that.mainDataConfig.mhObjObjName
      if ((!that.loadByMainObj) || (objCode === '')) {
        return ''
      }
      const lang = localStorage.getItem('lang')
      const para = {
        mhobjCode: objCode,
        mhobjdCode: objCode,
        mhobjLang: lang,
        mhobjApp: '',
        mhobjSite: ''
      }
      const { data: res } = await that.$http.post('/users/queryByObj', para)
      if (res.data) {
        const objMstr = res.data.mhobjMstr
        if ((objMstr) && (objMstr !== null)) {
          that.mainPostUrl.queryUrl = objMstr.mhobjQueryUrl
          that.mainPostUrl.postUrl = objMstr.mhobjPostUrl
          that.mainDataConfig.keyProps = that.$Any.strToArray(objMstr.mhobjKeyProps, ',')
          that.mainDataConfig.chkProp = objMstr.mhobjChkProp
          that.mainDataConfig.chkPara.ChkbyProp = objMstr.mhobjChkbyProp
          that.mainDataConfig.chkPara.ChkdateProp = objMstr.mhobjChkdateProp
          that.mainDataConfig.chkUrl = objMstr.mhobjChkUrl
          that.mainDataConfig.entityTable = objMstr.mhobjTable
          that.mainDataConfig.querySql = objMstr.mhobjQuerySql
          that.mainDataConfig.refreshDataUrl = objMstr.mhobjRefreshUrl
          that.mainDataConfig.postChkPara.postChkUrl = objMstr.mhobjPostchkUrl
          that.mainDataConfig.postChkPara.procName = objMstr.mhobjPostchkProc
        }
        const list = res.data.mhobjdDetList
        const columns = []
        for (const i in list) {
          that.mainObjectPropsDefault[list[i].mhobjdProp] = that.$Any.getTypeDefaultValue(list[i].mhobjdType)
          // const defaultValue = that.$Any.getDefaultValue(list[i].mhobjdDefault, list[i].mhobjdType)
          let hqField = list[i].mhobjdHqField
          if ((hqField === '') && (list[i].mhobjdHq !== '')) {
            hqField = list[i].mhobjdProp
          }
          const rstField = that.$Any.strToArray(hqField, ',')
          // 添加multitkField
          if (list[i].mhobjdCrtField) {
            that.mainDataConfig.crtField = list[i].mhobjdProp
          }
          if (list[i].mhobjdMultitkField) {
            that.mainDataConfig.multitkField = list[i].mhobjdProp
          }
          let maplist = {}
          if (this.isMultiTk && list[i].mhobjdMultitkField) {
            maplist = await that.$Any.getMultitkOptions(that.codesStr)
          } else {
            maplist = await that.$Any.getMapkvOptions(list[i].mhobjdMapvalues, that.constObj_)
          }
          let allow = true
          if (list[i].mhobjdFieldPerm !== '') {
            allow = await that.$Any.checkPerm(that.uuId_, list[i].mhobjdFieldPerm)
          }
          const onInsertStr = list[i].mhobjdOninsert
          let onInsert = {}
          if (onInsertStr !== '') {
            onInsert = JSON.parse(onInsertStr)
          }
          // let gridSlot = []
          // if (list[i].mhobjdGridSlot !== '') {
          //   gridSlot = JSON.parse(list[i].mhobjdGridSlot)
          // }
          const gridSlotStr = list[i].mhobjdGridSlot
          let gridSlot = {}
          if (gridSlotStr !== '') {
            gridSlot = JSON.parse(gridSlotStr)
          }
          columns.push({
            key: list[i].mhobjdProp,
            col: list[i].mhobjdCols,
            row: list[i].mhobjdRows,
            align: list[i].mhobjdGridAlign,
            textRows: list[i].mhobjdMin,
            type: list[i].mhobjdType,
            prop: list[i].mhobjdProp,
            label: list[i].mhobjdLabel,
            width: list[i].mhobjdWidth,
            mainKey: list[i].mhobjdMainKey,
            required: list[i].mhobjdRequired,
            clearable: list[i].mhobjdClearable,
            display: list[i].mhobjdDisplay && allow,
            formDisplay: list[i].mhobjdFormDisplay && allow,
            order: list[i].mhobjdOrder,
            formOrder: list[i].mhobjdFormOrder,
            typeExtends: list[i].mhobjdTypeExtends,
            readOnly: list[i].mhobjdReadonly,
            default: list[i].mhobjdDefault,
            format: list[i].mhobjdFormat,
            hq: list[i].mhobjdHq,
            rstField: rstField,
            ref: list[i].mhobjdRef,
            refObj: list[i].mhobjdRefObj,
            refObjCond: list[i].mhobjdRefCondition,
            icon: list[i].mhobjdTrigger,
            validType: list[i].mhobjdValidatorType,
            validator: list[i].mhobjdValidator,
            overToolTip: list[i].mhobjdOvertooltip,
            efileParas: list[i].mhobjdFileParas,
            gridSort: list[i].mhobjdGridSort,
            gridFixed: list[i].mhobjdGridFixed,
            zeroShow: list[i].mhobjdZeroShow,
            gridSlot: gridSlot,
            onInsert: onInsert,
            mapValues: maplist
          })
          const aRules = []
          if (list[i].mhobjdRequired === true) {
            aRules.push({
              required: true,
              message: list[i].mhobjdLabel + that.$t('form.EditBase.notBeEmpty'),
              trigger: 'blur'
            })
          }
          if ((list[i].mhobjdLength > 0) && (list[i].mhobjdType === 'string')) {
            aRules.push({
              max: list[i].mhobjdLength,
              message: that.$t('form.EditBase.characterLength') + list[i].mhobjdLength,
              trigger: 'blur'
            })
          }
          if (list[i].mhobjdValidator !== '') {
            aRules.push({
              validator: (rule, value, callback) => {
                const oldValue = that.mainObjectPropsOld[list[i].mhobjdProp]
                that.$Any.bindValidator(value, callback, that, that.mainObjectProps, oldValue, that.mainObjectState, that.mPost, list[i].mhobjdValidator)
              },
              trigger: 'blur'
            })
          }
          if (list[i].mhobjdOnset !== '') {
            aRules.push({
              validator: (rule, value, callback) => {
                const oldValue = that.mainObjectPropsOld[list[i].mhobjdProp]
                that.$Any.bindValidatorSet(value, callback, that, that.mainObjectProps, oldValue, that.mainObjectState, that.mPost, list[i].mhobjdOnset)
              },
              trigger: 'blur'
            })
          }
          if (list[i].mhobjdValidatorChange !== '') {
            aRules.push({
              validator: (rule, value, callback) => {
                const oldValue = that.mainObjectPropsOld[list[i].mhobjdProp]
                that.$Any.bindValidatorChange(value, callback, that, that.mainObjectProps, oldValue, that.mainObjectState, that.mPost, list[i].mhobjdValidatorChange)
              },
              trigger: 'change'
            })
          }
          that.mainRules[list[i].mhobjdProp] = aRules
        }
        that.mainColumns = columns
      }
    },
    loadDetGridData: function () {
      const that = this
      if ((that.hasDetGrid) && (that.mainDataChangeFlag)) {
        that.loadDetData().then(function () {
          that.setDetGridCurrent(that.detData[0])
          that.$refs.editslot.adjustDetGridHeight()
          const aftLoadDetData = that.aftLoadDetDataExt
          if (typeof aftLoadDetData === 'function') {
            aftLoadDetData(that.detData)
          }
          if (that.dynamicFuncs._loadDetDataAft) {
            that.dynamicFuncs._loadDetDataAft(that)
          }
        })
      }
    },
    // 确认当前用户是否为审核代理人
    loadUproxDetUser: async function () {
      const that = this
      const para = {}
      para.uutkCode = that.uutkMstr.uutkCode
      para.uutkDuty = that.uutkMstr.uutkDuty
      para.uuId = that.uuId_
      const { data: res } = await that.$http.post('/tk/getUproxDetUser', para)
      if (res.data) {
        that.UproxUser = res.data
      }
    },
    loadUutkMstr: async function () {
      const that = this
      const props = that.mainDataConfig.keyProps
      const nbr = that.mainObjectProps[props[0]]
      let lot = ''
      if (props.length > 1) {
        lot = that.mainObjectProps[props[1]]
      }
      const para = {
        uutkRefNbr: nbr,
        uutkRefLot: lot,
        uutkRefLine: 10
      }
      const { data: res } = await that.$http.post('/tk/selectUutkByRef', para)
      if (res.data) {
        that.uutkMstr = res.data
      } else {
        that.uutkMstr = null
      }
      if (that.uutkMstr) {
        that.loadUtkdDet()
        that.loadUproxDetUser()
      }
    },
    loadUtkdDet: async function () {
      const that = this
      const uutkRefNbr = that.uutkMstr.uutkRefNbr
      const uutkRefLot = that.uutkMstr.uutkRefLot
      const uutkRefLine = that.uutkMstr.uutkRefLine
      const para = {
        utkdNbr: uutkRefNbr,
        utkdLot: uutkRefLot,
        utkdLine: uutkRefLine
      }
      const { data: res } = await that.$http.post('/tk/getUtkdDetByNbr', para)
      if (res.data) {
        that.utkdDet = res.data
      } else {
        that.utkdDet = null
      }
      if (that.utkdDet) {
        that.loadApprObjects()
      }
    },
    loadApprObjects: async function () {
      const that = this
      const utkdNext = that.utkdDet.utkdNext
      if (utkdNext.indexOf('|') > 0) {
        that.uutkNextRequire = true
        that.apprNextList_ = []
        const pn = {
          utkdNbr: that.utkdDet.utkdNbr,
          utkdLot: that.utkdDet.utkdLot,
          utkdLine: that.utkdDet.utkdLine,
          utkdNext: utkdNext
        }
        const { data: res } = await that.$http.post('/tk/getUtkdNext', pn)
        if (res.data) {
          that.apprNextList_ = res.data
        } else {
          that.apprNextList_ = []
        }
      }
      const utkdRtnTk = that.utkdDet.utkdRtnTk
      if (utkdRtnTk.indexOf('|') > 0) {
        that.uutkRtnRequire = true
        that.apprRtnList_ = []
        const pn = {
          utkdNbr: that.utkdDet.utkdNbr,
          utkdLot: that.utkdDet.utkdLot,
          utkdLine: that.utkdDet.utkdLine,
          utkdNext: utkdRtnTk
        }
        const { data: res } = await that.$http.post('/tk/getUtkdNext', pn)
        if (res.data) {
          that.apprRtnList_ = res.data
        } else {
          that.apprRtnList_ = []
        }
      }
      const utkdCanTurn = that.utkdDet.utkdCanTurn
      if (utkdCanTurn) {
        that.apprTurnUserList_ = []
        const pt = {
          utkdNbr: that.utkdNbr,
          utkdLot: that.utkdLot,
          utkdLine: that.utkdLine,
          currentUser: that.uuId_,
          utkdTurnUser: that.utkdTurnUser
        }
        const { data: res } = await that.$http.post('/tk/getUtkdTurnUser', pt)
        if (res.data) {
          that.apprTurnUserList_ = res.data
        } else {
          that.apprTurnUserList_ = []
        }
      }
    },
    loadUtkMstr: async function () {
      const that = this
      const props = that.mainDataConfig.keyProps
      const nbr = that.mainObjectProps[props[0]]
      if (!nbr) {
        that.utkMstr = null
        return
      }
      let lot = ''
      if (props.length > 1) {
        lot = that.mainObjectProps[props[1]]
      }
      const para = {
        utkNbr: nbr,
        utkLot: lot
      }
      const { data: res } = await that.$http.post('/tk/getUtkMstrById', para)
      if (res.data) {
        that.utkMstr = res.data
      } else {
        that.utkMstr = null
      }
      that.loadtkStyleValue().then(() => {
        that.getFlowDatas()
      })
      that.$refs.editslot.adjustUtkFlowGridHeight()
    },
    loadDetData: async function () {
      const that = this
      const url = that.detPostUrl.queryUrl
      const para = that.getDetailParaData()
      const { data: res } = await that.$http.post(url, para)
      if (res.data) {
        this.detData = res.data.list
        this.detDataConfig.total = res.data.total
        this.mainDataChangeFlag = false
      }
    },
    getHraderCondition (para) {
      if (Object.keys(para).length > 0) {
        para.qField = humps.decamelize(para.qField)
        this.mainDataConfig.hraderCondition = para
        this.queryQueryExec()
      }
      // return val
    },
    loadMainData: async function (qryFlag) {
      const that = this
      if ((!that.autoLoadData) && (!qryFlag)) {
        return
      }
      const url = that.mainPostUrl.queryUrl
      let fixParaCondition = []
      fixParaCondition = fixParaCondition.concat(that.mainDataConfig.dataParas.filter)
      // const a = this.getHraderCondition()
      if (Object.keys(this.mainDataConfig.hraderCondition).length > 0) {
        fixParaCondition.push(this.mainDataConfig.hraderCondition)
      }
      const crtField = that.mainDataConfig.crtField
      if ((crtField !== '') && (!that.upMstr.upModifyAll) && (!that.upMstr.upUserAll)) {
        fixParaCondition.push({
          qJoin: 'and',
          qField: humps.decamelize(crtField),
          qOp: '=',
          qValue: that.uuId_,
          qType: 'string'
        })
      }
      const dynamicCondition = that.mainDataConfig.queryConditions.filter(item => {
        return item.qField !== ''
      })
      const dynamicCondition2 = []
      for (const item of dynamicCondition) {
        const newItem = Object.assign({}, item)
        if ((item.qOp === 'like') && (item.qValue.indexOf('%') < 0)) {
          newItem.qValue = '%' + item.qValue + '%'
        }
        if (item.qDetSQl !== '') {
          newItem.qDetSQl = newItem.qDetSQl.replace(/\?/gi, that.$Any.getSqlValue(newItem.qType, newItem.qValue))
        }
        dynamicCondition2.push(newItem)
      }
      that.mainDataConfig.dataParas.para.condition = dynamicCondition2.concat(fixParaCondition)
      if (that.mainDataConfig.orderField !== '') {
        that.mainDataConfig.dataParas.para.order = []
        that.mainDataConfig.dataParas.para.order.push({
          oField: that.mainDataConfig.orderField,
          osc: that.mainDataConfig.ascType
        })
      }
      that.mainDataConfig.dataParas.para.querySql = that.mainDataConfig.querySql
      that.mainDataConfig.dataParas.para.columns = that.mainColumns
      const para = that.mainDataConfig.dataParas.para
      const { data: res } = await that.$http.post(url, para)
      if (res.data) {
        that.mainData = res.data.list
        that.mainDataConfig.total = res.data.total
        if (res.data.total > 0) {
          that.mainObjectState = 0
        }
      }
    },
    chkMainData: async function () {
      const that = this
      const procName = that.mainDataConfig.postChkPara.procName
      that.mainDataConfig.postChkPara.para = {}
      if (procName !== '') {
        const list = this.mainColumns
        for (const i in list) {
          const newObj = {}
          const prop = list[i].prop
          const type = list[i].type
          newObj.value = this.mainObjectProps[prop]
          newObj.type = type
          if ((!list[i].ref) && (prop !== '')) {
            that.mainDataConfig.postChkPara.para['@' + prop] = newObj
          }
        }
        that.mainDataConfig.postChkPara.para['@code'] = {
          type: 'string',
          value: this.code
        }
        that.mainDataConfig.postChkPara.para['@lang'] = {
          type: 'string',
          value: this.lang_
        }
        that.mainDataConfig.postChkPara.para['@site'] = {
          type: 'string',
          value: this.site_
        }
        that.mainDataConfig.postChkPara.para['@mnId'] = {
          type: 'string',
          value: this.mnId_
        }
        that.mainDataConfig.postChkPara.para['@uuId'] = {
          type: 'string',
          value: this.uuId_
        }
        that.mainDataConfig.postChkPara.para['@action'] = {
          type: 'string',
          value: this.action_
        }
        const url = that.mainDataConfig.postChkPara.postChkUrl
        const { data: res } = await this.$http.post(url, that.mainDataConfig.postChkPara)
        return res
      } else {
        return { flag: -1, msg: '' }
      }
    },
    postMainData_: async function () {
      const currentData = this.mainObjectProps
      const para = {
        action: this.action_,
        data: currentData,
        entityTable: this.mainDataConfig.entityTable,
        columns: this.mainColumns
      }
      const url = this.mainPostUrl.postUrl
      const { data: res } = await this.$http.post(url, para)
      let index = currentData.index
      // const arrayIndex = this.$Any.getArrayIndexByDefProp(this.mainData, 'index', index)
      if (res === 1) {
        const md = this.mainData
        let msg = ''
        if (this.mainObjectState === 1) {
          msg = this.$t('form.EditBase.modificationSucceeded')
        } else if (this.mainObjectState === 2) {
          msg = this.$t('form.EditBase.addedSuccessfully')
        } else if (this.mainObjectState === 3) {
          msg = this.$t('form.EditBase.deletedSuccessfully')
        }
        if (this.mainObjectState === 3) {
          const len = md.length
          if (len === 1) {
            this.currentIndex = -1
          } else {
            if (index + 1 === len) {
              this.currentIndex = index - 1
            } else {
              this.currentIndex = index
            }
          }
          md.splice(index, 1)
          index = this.currentIndex
          const obj = this.mainData[index]
          // const obj = this.$Any.getArrayObjByDefProp(md, 'index', index + 1)
          const that = this
          // setTimeout(function () {
          //   that.setMainGridCurrent(obj)
          // }, 250)
          that.setMainGridCurrent(obj)
          // if (index === -1) {
          //   // this.setMainDefaultProps()
          //   setTimeout(function () {
          //     that.setMainGridCurrent(that.mainObjectPropsDefault)
          //   }, 250)
          // } else {
          //   setTimeout(function () {
          //     that.setMainGridCurrent(obj)
          //   }, 250)
          // }
        } else {
          for (const key in currentData) {
            md[index][key] = currentData[key]
          }
          this.mainObjectState = 0
        }
        this.$notify.info({
          title: this.$t('form.EditBase.messageBox'),
          message: msg,
          position: 'bottom-right',
          duration: 2000
        })
        // this.mainObjectState = 0
      }
      this.mPost = false
    },
    postMainData: async function () {
      const that = this
      that.getDetailParaData()
      that.getAttachGenParas()
      that.chkMainData().then(function (res) {
        const flag = res.flag
        const msg = res.msg
        if (flag !== -1) {
          if (that.mainObjectState === 3) {
            that.mainObjectState = 0
          }
          that.$alert(msg, that.$t('form.EditBase.messageBox'), {
            confirmButtonText: that.$t('form.EditBase.confirm')
          })
          that.mPost = false
        } else {
          const befAction = that.action_
          that.postMainData_().then(async function () {
            if (befAction !== '') {
              const aftPostMainDataExt = that.aftPostMainDataExt
              if (typeof aftPostMainDataExt === 'function') {
                aftPostMainDataExt(befAction, that.mainData)
              }
              if (that.dynamicFuncs._aftPostMainData) {
                that.dynamicFuncs._aftPostMainData(that, befAction)
              }
              const { data: rs } = await that.$http.post('/users/autoGenAttachDet', that.attachGenParas)
              const f = rs.flag
              const m = rs.msg
              if (f !== -1) {
                that.$alert(m, that.$t('form.EditBase.Attachment'), {
                  confirmButtonText: that.$t('form.EditBase.confirm')
                })
              }
              if (befAction === 'delete') {
                const { data: rs2 } = await that.$http.post('/users/autoDeleteUtkd', that.attachGenParas)
                const f2 = rs2.flag
                const m2 = rs2.msg
                if (f2 !== -1) {
                  that.$alert(m2, that.$t('form.EditBase.tipAutoDelete'), {
                    confirmButtonText: that.$t('form.EditBase.confirm')
                  })
                }
              }
            }
          })
        }
      })
    },
    chkDetData: async function () {
      const that = this
      const procName = that.detDataConfig.postChkPara.procName
      that.detDataConfig.postChkPara.para = {}
      if (procName !== '') {
        const list = this.detColumns
        for (const i in list) {
          const newObj = {}
          const prop = list[i].prop
          const type = list[i].type
          newObj.value = this.detObjectProps[prop]
          newObj.type = type
          if ((!list[i].ref) && (prop !== '')) {
            that.detDataConfig.postChkPara.para['@' + prop] = newObj
          }
        }
        that.detDataConfig.postChkPara.para['@code'] = {
          type: 'string',
          value: this.code
        }
        that.detDataConfig.postChkPara.para['@lang'] = {
          type: 'string',
          value: this.lang_
        }
        that.detDataConfig.postChkPara.para['@site'] = {
          type: 'string',
          value: this.site_
        }
        that.detDataConfig.postChkPara.para['@mnId'] = {
          type: 'string',
          value: this.mnId_
        }
        that.detDataConfig.postChkPara.para['@uuId'] = {
          type: 'string',
          value: this.uuId_
        }
        that.detDataConfig.postChkPara.para['@action'] = {
          type: 'string',
          value: this.detAction_
        }
        const url = that.detDataConfig.postChkPara.postChkUrl
        const { data: res } = await this.$http.post(url, that.detDataConfig.postChkPara)
        return res
      } else {
        return { flag: -1, msg: '' }
      }
    },
    postDetData_: async function () {
      const currentData = this.detObjectProps
      const para = {
        action: this.detAction_,
        data: currentData,
        entityTable: this.detDataConfig.entityTable,
        columns: this.detColumns
      }
      const url = this.detPostUrl.postUrl
      const { data: res } = await this.$http.post(url, para)
      let index = currentData.index

      if (res === 1) {
        let msg = ''
        if (this.detObjectState === 1) {
          msg = this.$t('form.EditBase.modificationSucceeded')
        } else if (this.detObjectState === 2) {
          msg = this.$t('form.EditBase.addedSuccessfully')
        } else if (this.detObjectState === 3) {
          msg = this.$t('form.EditBase.deletedSuccessfully')
        }

        const md = this.detData
        if (this.detObjectState === 3) {
          const len = md.length
          if (len === 1) {
            this.detCurrentIndex = -1
          } else {
            if (index + 1 === len) {
              this.detCurrentIndex = index - 1
            } else {
              this.detCurrentIndex = index
            }
          }
          md.splice(index, 1)
          index = this.detCurrentIndex
          const obj = this.detData[index]
          const that = this
          that.setDetGridCurrent(obj)
          // setTimeout(function () {
          //   that.setDetGridCurrent(obj)
          // }, 250)
          // if (index === -1) {
          //   this.setDetDefaultProps()
          // } else {
          //   setTimeout(function () {
          //     that.setDetGridCurrent(obj)
          //   }, 250)
          // }
        } else {
          for (const key in currentData) {
            md[index][key] = currentData[key]
          }
          this.detObjectState = 0
        }
        this.$notify.info({
          title: this.$t('form.EditBase.messageBox'),
          message: msg,
          position: 'bottom-right',
          duration: 2000
        })
        // this.detObjectState = 0
      }
      this.dPost = false
    },
    postDetData: async function () {
      const that = this
      const befAction = that.detAction_
      that.chkDetData().then(function (res) {
        const flag = res.flag
        const msg = res.msg
        if (flag !== -1) {
          if (that.detObjectState === 3) {
            that.detObjectState = 0
          }
          that.$alert(msg, that.$t('form.EditBase.messageBox'), {
            confirmButtonText: that.$t('form.EditBase.confirm')
          })
          that.dPost = false
        } else {
          that.postDetData_().then(async function () {
            const aftPostDetDataExt = that.aftPostDetDataExt
            if (typeof aftPostDetDataExt === 'function') {
              aftPostDetDataExt(befAction, that.detData)
            }
            if (that.dynamicFuncs._aftPostDetData) {
              that.dynamicFuncs._aftPostDetData(that, befAction)
            }
          })
        }
      })
    },
    loadMhobjdDetObj: async function () {
      const that = this
      const objCode = that.detDataConfig.mhObjObjName
      if ((!that.loadByDetObj) || (objCode === '')) {
        return ''
      }
      const lang = localStorage.getItem('lang')
      const para = {
        mhobjCode: objCode,
        mhobjdCode: objCode,
        mhobjLang: lang,
        mhobjApp: '',
        mhobjSite: ''
      }
      const { data: res } = await that.$http.post('/users/queryByObj', para)
      if (res.data) {
        const objMstr = res.data.mhobjMstr
        if ((objMstr) && (objMstr !== null)) {
          that.detPostUrl.queryUrl = objMstr.mhobjQueryUrl
          that.detPostUrl.postUrl = objMstr.mhobjPostUrl
          let joinProps = {}
          if ((objMstr.mhobjJoinProps) && (objMstr.mhobjJoinProps !== '')) {
            joinProps = JSON.parse(objMstr.mhobjJoinProps)
          }
          that.detDataConfig.keyProps = that.$Any.strToArray(objMstr.mhobjKeyProps, ',')
          that.detDataConfig.joinProps = joinProps
          that.detDataConfig.chkProp = objMstr.mhobjChkProp
          that.detDataConfig.chkUrl = objMstr.mhobjChkUrl
          that.detDataConfig.entityTable = objMstr.mhobjTable
          that.detDataConfig.querySql = objMstr.mhobjQuerySql
          that.detDataConfig.refreshDataUrl = objMstr.mhobjRefreshUrl
          that.detDataConfig.postChkPara.postChkUrl = objMstr.mhobjPostchkUrl
          that.detDataConfig.postChkPara.procName = objMstr.mhobjPostchkProc
        }
        const list = res.data.mhobjdDetList
        const columns = []
        for (const i in list) {
          that.detObjectPropsDefault[list[i].mhobjdProp] = that.$Any.getTypeDefaultValue(list[i].mhobjdType)
          // const defaultValue = that.$Any.getDefaultValue(list[i].mhobjdDefault, list[i].mhobjdType)
          let hqField = list[i].mhobjdHqField
          if ((hqField === '') && (list[i].mhobjdHq !== '')) {
            hqField = list[i].mhobjdProp
          }
          const rstField = that.$Any.strToArray(hqField, ',')
          const maplist = await that.$Any.getMapkvOptions(list[i].mhobjdMapvalues, that.constObj_)

          let allow = true
          if (list[i].mhobjdFieldPerm !== '') {
            allow = await that.$Any.checkPerm(that.uuId_, list[i].mhobjdFieldPerm)
          }
          const onInsertStr = list[i].mhobjdOninsert
          let onInsert = {}
          if (onInsertStr !== '') {
            onInsert = JSON.parse(onInsertStr)
          }
          // let gridSlot = []
          // if (list[i].mhobjdGridSlot !== '') {
          //   gridSlot = JSON.parse(list[i].mhobjdGridSlot)
          // }
          const gridSlotStr = list[i].mhobjdGridSlot
          let gridSlot = {}
          if (gridSlotStr !== '') {
            gridSlot = JSON.parse(gridSlotStr)
          }
          columns.push({
            key: list[i].mhobjdProp,
            col: list[i].mhobjdCols,
            row: list[i].mhobjdRows,
            align: list[i].mhobjdGridAlign,
            textRows: list[i].mhobjdMin,
            type: list[i].mhobjdType,
            prop: list[i].mhobjdProp,
            label: list[i].mhobjdLabel,
            width: list[i].mhobjdWidth,
            mainKey: list[i].mhobjdMainKey,
            required: list[i].mhobjdRequired,
            clearable: list[i].mhobjdClearable,
            display: list[i].mhobjdDisplay && allow,
            formDisplay: list[i].mhobjdFormDisplay && allow,
            order: list[i].mhobjdOrder,
            formOrder: list[i].mhobjdFormOrder,
            typeExtends: list[i].mhobjdTypeExtends,
            readOnly: list[i].mhobjdReadonly,
            default: list[i].mhobjdDefault,
            format: list[i].mhobjdFormat,
            hq: list[i].mhobjdHq,
            rstField: rstField,
            ref: list[i].mhobjdRef,
            refObj: list[i].mhobjdRefObj,
            refObjCond: list[i].mhobjdRefCondition,
            icon: list[i].mhobjdTrigger,
            validType: list[i].mhobjdValidatorType,
            validator: list[i].mhobjdValidator,
            overToolTip: list[i].mhobjdOvertooltip,
            efileParas: list[i].mhobjdFileParas,
            gridSort: list[i].mhobjdGridSort,
            gridFixed: list[i].mhobjdGridFixed,
            zeroShow: list[i].mhobjdZeroShow,
            gridSlot: gridSlot,
            onInsert: onInsert,
            mapValues: maplist
          })
          const aRules = []
          if (list[i].mhobjdRequired === true) {
            aRules.push({
              required: true,
              message: list[i].mhobjdLabel + that.$t('form.EditBase.notBeEmpty'),
              trigger: 'blur'
            })
          }
          if ((list[i].mhobjdLength > 0) && (list[i].mhobjdType === 'string')) {
            aRules.push({
              max: list[i].mhobjdLength,
              message: that.$t('form.EditBase.characterLength') + list[i].mhobjdLength,
              trigger: 'blur'
            })
          }
          if (list[i].mhobjdValidator !== '') {
            aRules.push({
              validator: (rule, value, callback) => {
                const oldValue = that.detObjectPropsOld[list[i].mhobjdProp]
                that.$Any.bindValidator(value, callback, that, that.detObjectProps, oldValue, that.detObjectState, that.dPost, list[i].mhobjdValidator)
              },
              trigger: 'blur'
            })
          }
          if (list[i].mhobjdOnset !== '') {
            aRules.push({
              validator: (rule, value, callback) => {
                const oldValue = that.detObjectPropsOld[list[i].mhobjdProp]
                that.$Any.bindValidatorSet(value, callback, that, that.detObjectProps, oldValue, that.detObjectState, that.dPost, list[i].mhobjdOnset)
              },
              trigger: 'blur'
            })
          }
          if (list[i].mhobjdValidatorChange !== '') {
            aRules.push({
              validator: (rule, value, callback) => {
                const oldValue = that.detObjectPropsOld[list[i].mhobjdProp]
                that.$Any.bindValidatorChange(value, callback, that, that.detObjectProps, oldValue, that.detObjectState, that.dPost, list[i].mhobjdValidatorChange)
              },
              trigger: 'change'
            })
          }
          that.detRules[list[i].mhobjdProp] = aRules
        }
        that.detColumns = columns
      }
    },
    setMainDefaultProps: function () {
      // const list = this.mainColumns
      // for (const i in list) {
      //   this.mainObjectProps[list[i].prop] = list[i].default
      // }
      this.mainObjectProps = this.mainObjectPropsDefault
      this.mainObjectPropsOld = this.mainObjectPropsDefault
      if (this.$refs.mainFormRef) {
        this.$refs.mainFormRef.clearValidate()
      }
    },
    setDetDefaultProps: function () {
      // const list = this.detColumns
      // for (const i in list) {
      //   this.detObjectProps[list[i].prop] = list[i].default
      // }
      this.detObjectProps = this.detObjectPropsDefault
      this.detObjectPropsOld = this.detObjectPropsDefault
      if (this.$refs.detFormRef) {
        this.$refs.detFormRef.clearValidate()
      }
    },
    startPostDetData: function () {
      const that = this
      that.dPost = true
      try {
        that.$refs.detFormRef.validate((valid) => {
          if (valid) {
            that.postDetData()
          } else {
            that.dPost = false
            return false
          }
        })
      } catch (e) {
        that.dPost = false
      }
    },
    saveDetDataExec: function () {
      if (this.detObjectState === 0) {
        this.$notify.info({
          title: this.$t('form.EditBase.messageBox'),
          message: this.$t('form.EditBase.notNeedToSave'),
          position: 'bottom-right',
          duration: 2000
        })
      } else {
        this.startPostDetData()
        // this.$refs.detFormRef.validate((valid) => {
        //   if (valid) {
        //     this.postDetData()
        //   } else {
        //     return false
        //   }
        // })
      }
    },
    getAutoNbr: async function (onInsertObj) {
      const that = this
      const code = onInsertObj.para.code
      return that.$Any.autoNbr(code)
    },
    // getHrAutoNbr: async function (onInsertObj) {
    //   const that = this
    //   const code = onInsertObj.para.code
    //   const site = onInsertObj.para.site
    //   return that.$Any.hrAutoNbr(code, site)
    // },
    getHrAutoNbr: async function (onInsertObj) {
      const that = this
      const code = onInsertObj.para.code
      return that.$Any.hrAutoNbr(code)
    },
    getScmAutoNbr: async function (onInsertObj) {
      const that = this
      const code = onInsertObj.para.code
      return that.$Any.scmAutoNbr(code)
    },
    getEamAutoNbr: async function (onInsertObj) {
      const that = this
      const code = onInsertObj.para.code
      return that.$Any.eamAutoNbr(code)
    },
    getDetNewLine: async function (onInsertObj) {
      const obj = {}
      const props = this.mainDataConfig.keyProps
      const detKeyProps = this.detDataConfig.joinProps
      for (const i in props) {
        const detKey_ = humps.decamelize(detKeyProps[props[i]])
        obj[detKey_] = this.mainObjectProps[props[i]]
      }
      onInsertObj.para.condition = obj
      const { url, para } = onInsertObj
      if (url) {
        const { data: res } = await this.$http.post(url, para)
        return res
      } else {
        return 0
      }
    },
    setOnInsertValue: function (obj, prop, onInsertObj, func) {
      let udefunc = null
      if ((typeof func) === 'string') {
        // eslint-disable-next-line no-eval
        eval('udefunc=' + func)
      } else {
        udefunc = func
      }
      udefunc(onInsertObj).then(function (rst) {
        obj[prop] = rst
      })
    },
    getFlowDatas: async function () {
      const that = this
      if (!that.tkStyleValue) {
        return
      }
      const props = that.mainDataConfig.keyProps
      if (that.mainObjectState === 0) {
        const nbr = that.mainObjectProps[props[0]]
        let lot = ''
        if (props.length > 1) {
          lot = that.mainObjectProps[props[1]]
        }
        const paras = {
          UTKNBR: nbr,
          UTKLOT: lot,
          UUUSER: that.uuId_,
          LEFT: 150,
          TOP: 30,
          STEPX: 150,
          STEPY: 100,
          CONNECT: 'Left,Right',
          TYPE: 'Flowchart',
          ZOOM: 1,
          STYLE: that.tkStyleValue
        }
        const { data: res } = await that.$http.post('/tk/drawWorkFlowStyle', paras)
        that.flowData = res.data
      }
    },
    // 发起流程
    pendFlowInit: async function () {
      const that = this
      // 流程发起前置事件
      let flag = true
      if (that.dynamicFuncs._pendFlowBefore) {
        flag = await that.dynamicFuncs._pendFlowBefore(that)
      }
      if (!flag) {
        return
      }

      that.$confirm(that.$t('form.EditBase.initiatedThisProcess'), that.$t('form.EditBase.pleaseConfirm'), {
        confirmButtonText: that.$t('form.EditBase.confirm'),
        cancelButtonText: that.$t('form.EditBase.cancel'),
        type: 'warning'
      }).then(async () => {
        const props = that.mainDataConfig.keyProps
        const multitkField = that.mainDataConfig.multitkField
        if (that.mainObjectState === 0) {
          // 多流程
          if (that.isMultiTk) {
            that.code = that.mainObjectProps[multitkField]
          }
          if (that.code === '') {
            that.$alert(that.$t('form.EditBase.flowCodeNotSet'), that.$t('form.EditBase.messageBox'), {
              confirmButtonText: that.$t('form.EditBase.confirm')
            })
            return
          }
          const nbr = that.mainObjectProps[props[0]]
          let lot = ''
          if (props.length > 1) {
            lot = that.mainObjectProps[props[1]]
          }
          const p = {
            TKNBR: nbr,
            TKLOT: lot,
            TKCODE: that.code,
            UUUSER: that.uuId_,
            LANG: that.lang_
          }

          const { data: res } = await this.$http.post('/tk/pendTk', p)
          const flag = res.flag
          const msg = res.msg
          if (flag !== -1) {
            that.$alert(msg, that.$t('form.EditBase.messageBox'), {
              confirmButtonText: that.$t('form.EditBase.confirm')
            })
          } else {
            // that.getFlowDatas()
            that.loadUtkMstr()
            that.loadUutkMstr()
          }
        }
      }).catch(() => {
      })
    },
    apprConfirmInit: async function () {
      const that = this
      that.uutkConfirm = true
      const para = {
        UUTKNBR: that.apprObject_.apprNbr,
        UUUSER: that.uuId_,
        ACTION: that.apprObject_.apprAction,
        NSTEP: that.apprObject_.apprNext,
        TURNUSER: that.apprObject_.apprTurnUser,
        TURNTYPE: that.apprObject_.apprTurnType,
        APINFO: that.apprObject_.apprInfo,
        LANG: that.lang_,
        utkdNbr: that.utkdDet.utkdNbr,
        utkdLot: that.utkdDet.utkdLot,
        utkdLine: that.utkdDet.utkdLine
      }
      const { data: res } = await this.$http.post('/tk/apprTk', para)
      const flag = res.flag
      const msg = res.msg
      if (flag !== -1) {
        that.$alert(msg, that.$t('form.EditBase.messageBox'), {
          confirmButtonText: that.$t('form.EditBase.confirm')
        })
      } else {
        that.$refs.editslot.showApprDlg = false
        that.loadUutkMstr()
        that.loadUtkMstr()
      }
      that.uutkConfirm = false
    },
    apprFlowInit: function (action) {
      this.apprObject_.apprAction = action
      this.apprObject_.apprNbr = this.uutkMstr.uutkNbr
      this.apprObject_.apprNextRequire = this.uutkNextRequire
      this.apprObject_.apprRtnRequire = this.uutkRtnRequire
      this.apprObject_.apprNext = ''
      this.apprObject_.apprTurnUser = ''
      this.apprObject_.apprTurnType = ''
      this.apprObject_.apprInfo = ''
      this.$refs.editslot.showApprDlg = true
    },
    newDetDataInit: function () {
      const list = this.detColumns
      const newObj = {}
      for (const i in list) {
        newObj[list[i].prop] = this.$Any.getDefaultValue(list[i].default, list[i].type)
        if ((list[i].onInsert) && (JSON.stringify(list[i].onInsert) !== '{}')) {
          this.setOnInsertValue(newObj, list[i].prop, list[i].onInsert, list[i].onInsert.function)
        }
      }
      const props = this.mainDataConfig.keyProps
      const detKeyProps = this.detDataConfig.joinProps
      for (const i in props) {
        newObj[detKeyProps[props[i]]] = this.mainObjectProps[props[i]]
      }
      const i = this.detData.length
      this.detCurrentIndexOld = this.detCurrentIndex
      this.detObjectPropsOld = this.detData[this.detCurrentIndexOld] || this.detObjectPropsDefault
      this.detData.push(newObj)
      this.setDetGridCurrent(this.detData[i])
      this.detCurrentIndex = i
      this.setDetFormData(newObj)
      this.detObjectState = 2

      this.$refs.editslot.showDetDrawer = true

      if (this.dynamicFuncs._detOnInsert) {
        this.dynamicFuncs._detOnInsert(this)
      }
    },
    deleteDetDataExec: function () {
      var that = this
      that.$confirm(that.$t('form.EditBase.deleteCurrentData'), that.$t('form.EditBase.pleaseConfirm'), {
        confirmButtonText: that.$t('form.EditBase.confirm'),
        cancelButtonText: that.$t('form.EditBase.cancel'),
        type: 'warning'
      }).then(() => {
        that.detObjectState = 3
        that.postDetData()
      }).catch(() => {
      })
    },
    cancelDetDataExec: function () {
      if (this.detObjectState === 1) {
        for (const key in this.detObjectPropsOld) {
          this.detObjectProps[key] = this.detObjectPropsOld[key]
        }
        this.detObjectState = 0
      } else if (this.detObjectState === 2) {
        const cIndex = this.detCurrentIndex
        const oldIndex = this.detCurrentIndexOld
        this.detData.splice(cIndex, 1)
        this.setDetGridCurrent(this.detData[oldIndex])
        // if ((cIndex === 0) && (oldIndex === 0)) {
        //   // this.setDetDefaultProps()
        //   this.detObjectState = -1
        // } else {
        //   this.detObjectState = 0
        // }
      }
      this.$refs.detFormRef.clearValidate()
    },
    startPostMainData: function () {
      const that = this
      that.mPost = true
      try {
        that.$refs.mainFormRef.validate((valid) => {
          if (valid) {
            that.postMainData()
          } else {
            that.mPost = false
            return false
          }
        })
      } catch (e) {
        that.mPost = false
      }
    },
    saveMainDataExec: function () {
      if (this.mainObjectState === 0) {
        this.$notify.info({
          title: this.$t('form.EditBase.messageBox'),
          message: this.$t('form.EditBase.notNeedToSave'),
          position: 'bottom-right',
          duration: 2000
        })
      } else {
        this.startPostMainData()
        // this.$refs.mainFormRef.validate((valid) => {
        //   if (valid) {
        //     this.postMainData()
        //   } else {
        //     return false
        //   }
        // })
      }
    },
    newMainDataInit: function () {
      const list = this.mainColumns
      const newObj = {}
      for (const i in list) {
        newObj[list[i].prop] = this.$Any.getDefaultValue(list[i].default, list[i].type)
        if ((list[i].onInsert) && (JSON.stringify(list[i].onInsert) !== '{}')) {
          this.setOnInsertValue(newObj, list[i].prop, list[i].onInsert, list[i].onInsert.function)
        }
      }
      const i = this.mainData.length
      this.currentIndexOld = this.mainObjectProps.index
      this.mainObjectPropsOld = this.mainData[this.currentIndexOld] || this.mainObjectPropsDefault
      this.mainData.push(newObj)
      this.setMainGridCurrent(this.mainData[i])
      this.currentIndex = i
      this.setMainFormData(newObj)
      this.mainObjectState = 2

      if (this.dynamicFuncs._mainOnInsert) {
        this.dynamicFuncs._mainOnInsert(this)
      }
    },
    deleteMainDataExec: function () {
      var that = this
      that.$confirm(that.$t('form.EditBase.deleteCurrentData'), that.$t('form.EditBase.pleaseConfirm'), {
        confirmButtonText: that.$t('form.EditBase.confirm'),
        cancelButtonText: that.$t('form.EditBase.cancel'),
        type: 'warning'
      }).then(() => {
        that.mainObjectState = 3
        that.postMainData()
      }).catch(() => {
      })
    },
    cancelMainDataExec: function () {
      if (this.mainObjectState === 1) {
        for (const key in this.mainObjectPropsOld) {
          this.mainObjectProps[key] = this.mainObjectPropsOld[key]
        }
        this.mainObjectState = 0
      } else if (this.mainObjectState === 2) {
        const cIndex = this.currentIndex
        const oldIndex = this.currentIndexOld
        this.mainData.splice(cIndex, 1)
        this.setMainGridCurrent(this.mainData[oldIndex])
        // if ((cIndex === 0) && (oldIndex === 0)) {
        //   this.setMainDefaultProps()
        //   this.mainObjectState = -1
        // } else {
        //   this.mainObjectState = 0
        // }
      }
      this.$refs.mainFormRef.clearValidate()
    },
    queryDataExec: function () {
      this.$refs.editslot.showQueryDlg = true
    },
    addQueryExec: function () {
      const i = this.mainDataConfig.queryConditions.length
      this.mainDataConfig.queryConditions.push({
        qJoin: 'and',
        qField: '',
        qOp: '=',
        qValue: '',
        qType: 'string',
        qDetSQl: ''
      })
      this.queryIndex = i
      this.$refs.editslot.setQueryGridCurrent(this.mainDataConfig.queryConditions[i])
    },
    delQueryExec: function () {
      const len = this.mainDataConfig.queryConditions.length
      const index = this.queryIndex
      if (len === 1) {
        this.queryIndex = -1
      } else {
        if (index + 1 === len) {
          this.queryIndex = index - 1
        }
      }
      this.mainDataConfig.queryConditions.splice(index, 1)
      if (this.queryIndex !== -1) {
        this.$refs.editslot.setQueryGridCurrent(this.mainDataConfig.queryConditions[this.queryIndex])
      }
    },
    queryQueryExec: function () {
      const that = this
      // const fixParaCondition = that.mainDataConfig.dataParas.filter
      // const dynamicCondition = that.mainDataConfig.queryConditions.filter(item => {
      //   return item.qField !== ''
      // })
      // that.mainDataConfig.dataParas.para.condition = Object.assign(dynamicCondition, fixParaCondition)
      that.loadMainData(true).then(function () {
        that.setMainGridCurrent(that.mainData[0])
        that.activeTabEvents()
        const aftLoadMainData = that.aftLoadMainDataExt
        if (typeof aftLoadMainData === 'function') {
          aftLoadMainData()
        }
        if (that.dynamicFuncs._loadMainDataAft) {
          that.dynamicFuncs._loadMainDataAft(that)
        }
        that.$refs.editslot.showQueryDlg = false
      })
    },
    reportDialogCloseExec: function () {
      const that = this
      that.reportUrl = 'about:blank'
    },
    getMainSummaries (param) {
      const that = this
      if (that.dynamicFuncs._getMainSummaries) {
        return that.dynamicFuncs._getMainSummaries(that, param)
      } else {
        return []
      }
    },
    getDetSummaries (param) {
      const that = this
      if (that.dynamicFuncs._getDetSummaries) {
        return that.dynamicFuncs._getDetSummaries(that, param)
      } else {
        return []
      }
    },
    setScorll: function () {
      setTimeout(() => {
        const TableRows = this.$refs.mainGrid.bodyWrapper.querySelectorAll('.el-table__body tbody .el-table__row')
        let scrollTop = 0
        for (let i = 0; i < TableRows.length; i++) {
          if (i === this.currentIndex) {
            break
          }
          scrollTop += TableRows[i].offsetHeight
        }
        this.$refs.mainGrid.bodyWrapper.scrollTop = scrollTop - 100
        // this.$refs.mainGrid.bodyWrapper.scrollTop = this.scrollTop
      }, 500)
    },
    loadtkStyleList: async function () {
      const that = this
      that.$Any.getMapkvOptions('TKSTYLE').then(function (list) {
        that.tkStyleList_ = list.options
      })
    },
    loadtkStyleValue: async function () {
      const that = this
      const props = that.mainDataConfig.keyProps
      const nbr = that.mainObjectProps[props[0]]
      if (!nbr) {
        return
      }
      let lot = ''
      if (props.length > 1) {
        lot = that.mainObjectProps[props[1]]
      }
      const data = {
        querySql: 'select tk_style from tk_mstr left join utk_mstr on tk_code = utk_code where utk_nbr = :nbr and utk_lot = :lot',
        para: { nbr: nbr, lot: lot }
      }
      const { data: res } = await this.$http.post('/users/getObject', data)
      if (res.data) {
        that.tkStyleValue = res.data.tk_style
      }
      if (that.tkStyleValue === '') {
        that.tkStyleValue = 'H'
      }
    }
  },
  created () {

  },
  beforeCreate () {

  },
  beforeMount () {
    this.initConfig()
  },
  beforeDestroy () {
  },
  activated () {
  },
  mounted () {
  },
  watch: {
    currentIndex: {
      handler (newObj, oldObj) {

      }
    },
    mainObjectProps_: {
      handler (newObj, oldObj) {
        const keyProps = this.mainDataConfig.keyProps
        const state = this.mainObjectState
        if (this.$refs.mainGrid.bodyWrapper.scrollTop > 0) {
          this.scrollTop = this.$refs.mainGrid.bodyWrapper.scrollTop
        }
        if ((state === 1) || (state === 2) || (state === -1)) {
          return
        }
        let flag = true
        for (const keyKey in keyProps) {
          if (newObj[keyProps[keyKey]] !== oldObj[keyProps[keyKey]]) {
            flag = false
          }
        }
        if (flag) {
          for (const key in newObj) {
            if ((key !== 'index') && (newObj[key] !== oldObj[key])) {
              this.mainObjectPropsOld = oldObj
              this.mainObjectState = 1
            }
          }
        }
      },
      deep: true
    },
    detObjectProps_: {
      handler (newObj, oldObj) {
        const keyProps = this.detDataConfig.keyProps
        const state = this.detObjectState
        if ((state === 1) || (state === 2)) {
          return
        }
        let flag = true
        for (const keyKey in keyProps) {
          if (newObj[keyProps[keyKey]] !== oldObj[keyProps[keyKey]]) {
            flag = false
          }
        }
        if (flag) {
          for (const key in newObj) {
            if ((key !== 'index') && (newObj[key] !== oldObj[key])) {
              this.detObjectPropsOld = oldObj
              this.detObjectState = 1
            }
          }
        }
      },
      deep: true
    }
    // 'mainDataConfig.hraderCondition': {
    //   handler: function () {
    //     this.queryQueryExec()
    //   }
    // }
  }
}
</script>

<style lang="less" >

</style>
